<script>
import VDataTableCustom from "@/components/VDataTable/VDataTableCustom.vue";
import BusinessProcess from "@/mixins/BusinessProcess";

export default {
    name: "VDataTableDigests" ,
    components: {
        VDataTableCustom,
    },
    mixins: [
        BusinessProcess
    ],
    inheritAttrs: false,
    data() {
        return {
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id',
                    width: 100,
                    // filterComponent: 'VDataTableCustomHeaderFiltersText',
                    tooltip: 'Идентификатор в системе учета ESS',
                },
                {
                    text: '&#9776;',
                    align: 'start',
                    sortable: true,
                    value: 'language',
                    width: 50,
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    filterLabel: 'Язык',
                    tooltip: 'Язык',
                },
                {
                    text: 'Дата выхода',
                    align: 'left',
                    sortable: true,
                    value: 'date_origin',
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                    width: 100,
                },
                {
                    text: 'Дайджест',
                    align: 'start',
                    sortable: true,
                    cellClass: "text",
                    // filterComponent: 'VDataTableCustomHeaderFiltersText',
                    value: 'name',
                },
                {
                    text: 'БП',
                    align: 'start',
                    sortable: true,
                    value: 'approve_mask',
                    cellClass: 'status-field',
                    // filterFieldClass: 'status-field',
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    filterComponentProps: {
                        /**
                         * @TODO Получается несколько одинаковых значений?
                         */
                        mapValuesFn: this.getBusinessProcessState,
                        itemTextWithHtml: true,
                    },
                    tooltip: 'Состояние бизнес-процесса',
                    filterLabel: 'Состояние бизнес-процесса',
                    width: 150,
                },
                {
                    text: 'Создано',
                    align: 'center',
                    sortable: true,
                    value: 'created_at',
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                    width: 120,
                },
                {
                    text: 'Создано',
                    align: 'center',
                    sortable: true,
                    value: 'created_by_name',
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    width: 120,
                },
                {
                    text: 'Обновлено',
                    align: 'center',
                    sortable: true,
                    value: 'updated_at',
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                    width: 120,
                },
                {
                    text: 'Обновлено',
                    align: 'center',
                    sortable: true,
                    value: 'updated_by_name',
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    width: 120,
                },
            ],
        };
    },
    methods: {
        getItemClass(item) {
            return this.getBusinessProcessState(item.approve_mask, "class");
        }
    },
}
</script>

<template>
    <v-data-table-custom
        v-bind="$attrs"
        v-on="$listeners"
        :headers="headers"
        item-key="id"
        permissions-by-module="digests"
        :item-class="getItemClass"
    >
        <template v-slot:item.date_origin="{item}">
                {{ item.date_origin | moment('DD.MM.Y') }}
        </template>
    </v-data-table-custom>
</template>

<style scoped lang="scss">
::v-deep tr.bp_is_new {
    color: silver;
}

::v-deep tr.bp_is_in_progress {
    font-weight: normal;
}

::v-deep tr.bp_approved_by_editor,
::v-deep tr.bp_approved_by_approver,
::v-deep tr.bp_approved_by_moderator,
::v-deep tr.bp_is_approved {
    font-weight: 500;
}

::v-deep tr.bp_is_declined {
    font-weight: 500;
}

::v-deep tr.bp_is_declined .text {
    color: darkred;
}

::v-deep tr.bp_is_published .text {
    color: darkgreen;
}

::v-deep .status-field {
    width: 150px;
    max-width: 150px;
}
</style>